<template>
  <div class="tickets">
    <div ref="column-filter">
      <ColumnSelectFilter :columnSize="columnSize"
                          :columnMaxSize="columnMaxSize"
                          :filter="columnFilter"
                          :items="checkboxItems"
                          :message="columnMessage"
                          :messageTitle="translations['tableFiltersColumnsText']"
                          :selected="selectedColumns"
                          @inputFilter="setColumns"
                          @resetInputFilter="resetColumns">
      </ColumnSelectFilter>
    </div>
    <div>
      <Table :descending="sortOrder"
             :data="tickets"
             :headers="headers"
             :id="ticketId"
             :selected="selectedColumns"
             :sortColumn="paginationConfig.sortBy"
             :sortable="true"
             :type="'list'"
             @getItems="getTicketBets"
             @sortBy="sortTicketsBy">
      </Table>
      <div class="columns-icon">
        <i class="n-i n-i-columns"
           v-click-outside-element="columnFilterConfig"
           @click="columnFilter = !columnFilter">
        </i>
      </div>
    </div>
    <Pagination :page="paginationConfig.page"
                :row="pageSize"
                :rows="rowsPerPageItems"
                :totalItems="paginationConfig.totalCount"
                :totalPages="paginationConfig.totalPages"
                @setPages="setPagination">
    </Pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  first,
  filter,
  map,
  toLower,
} from 'lodash';
import { paginable } from '../mixins';
import ClickOutsideElement from '../directives/outside-element';
import ColumnSelectFilter from './ColumnSelectFilter';
import Pagination from './Pagination';
import Table from './Table';
import { bus } from '../utility';

export default {
  name: 'TicketList',
  components: {
    ColumnSelectFilter,
    Pagination,
    Table,
  },
  directives: {
    ClickOutsideElement,
  },
  mixins: [
    paginable,
  ],
  data() {
    return {
      headers: [
        { value: 'id', status: true },
        { value: 'barcode', status: true },
        { value: 'round', status: true },
        { value: 'result', status: true },
        { value: 'createdAt', status: true },
        { value: 'resolvedAt', status: false },
        { value: 'paidOutAt', status: true },
        { value: 'canceledAt', status: false },
        { value: 'totalStake', status: true },
        { value: 'totalPaymentTax', status: false },
        { value: 'totalPayment', status: false },
        { value: 'totalPayout', status: true },
        { value: 'jackpotWinAmount', status: false },
        { value: 'totalPayoutTax', status: false },
        { value: 'totalPayoutAfterTax', status: false },
        { value: 'totalPossiblePayoutTax', status: false },
        { value: 'totalPossiblePayout', status: false },
        { value: 'paymentBetshopName', status: false },
        { value: 'paymentOperatorName', status: false },
        { value: 'payoutBetshopName', status: false },
        { value: 'payoutOperatorName', status: false },
        { value: 'cancelBetshopName', status: false },
        { value: 'cancelOperatorName', status: false },
        { value: 'paymentRetailRegisterName', status: false },
        { value: 'paymentRetailRegisterId', status: false },
        { value: 'playerUsername', status: false },
        { value: 'icon', betslip: 'n-i n-i-betslip', status: true },
        { value: 'status', status: true, config: true },
        { icon: 'n-i n-i-columns', value: 'columns', status: true },
      ],
      columnFilterConfig: {
        exclude: ['column-filter'],
        handler: 'closeFilter',
      },
      descending: true,
      columnSize: null,
      checkboxItems: [],
      columnFilter: false,
      columnMessage: false,
      columnMaxSize: 16,
      selectedColumns: [],
      ticketId: null,
    };
  },
  watch: {
    selectedColumns() {
      const numberOfColumns = filter(this.selectedColumns, item => item).length;
      this.columnMessage = numberOfColumns > this.columnMaxSize
        ? this.columnMessage = !this.columnMessage : false;
      this.columnSize = numberOfColumns;
    },
    tickets() {
      if (this.tickets.length) {
        this.ticketId = first(this.tickets).id;
      }
    },
  },
  computed: {
    ...mapGetters([
      'config',
      'paginationConfig',
      'tickets',
      'translations',
      'wheel',
    ]),
    pageSize() {
      return this.paginationConfig.pageSize
        ? this.paginationConfig.pageSize
        : this.pagination.rowsPerPage;
    },
    sortOrder() {
      return toLower(this.paginationConfig.sortOrder) === 'desc';
    },
  },
  mounted() {
    this.selectedColumns = map(this.headers, item => item.status);
    this.checkboxItems = this.headers.slice(0, -1);
    bus.$on('restartFilters', () => {
      this.resetColumns();
    });
  },
  methods: {
    ...mapActions([
      'loadTicketBets',
    ]),
    closeFilter() {
      this.columnFilter = false;
    },
    resetColumns() {
      this.columnFilter = !this.columnFilter;
      this.selectedColumns = map(this.headers, item => item.status);
      this.columnSize = filter(this.selectedColumns, item => item).length;
    },
    getTicketBets(id) {
      if (this.ticketId !== id) {
        this.$emit('setLoader');
        this.loadTicketBets({
          wheelId: this.wheel.id,
          wheelAccountId: this.wheel.wheelAccountId,
          ticketId: id,
          locale: this.config.locale,
        });
        this.ticketId = id;
      }
    },
    setPagination(value) {
      this.$emit('pagination', value);
    },
    sortTicketsBy(value) {
      if (this.tickets.length && (value !== 'icon' && value !== 'columns' && value !== 'winAmount')) {
        this.descending = !this.descending;
        this.$emit('sortTickets', value);
      }
    },
    setColumns(values) {
      this.selectedColumns = values;
    },
  },
};
</script>
<style lang="scss" scoped>
.tickets {
  position: relative;
  width: 67%;

  .column-filter {
    margin-top: 30px;
    right: 0;
  }

  .columns-icon {
    color: #6b7585;
    font-size: 12px;
    position: absolute;
    right: 0;
    top: 0;
    margin: 8px;

    .n-i {
      cursor: pointer;
    }
  }

  .pagination {
    width: 99.8%;
  }
}
</style>
